import { jsx as a } from "react/jsx-runtime";
import { AuthProvider as i } from "react-oidc-context";
import { r as m } from "../utils-Dtrd3f8i.js";
const h = ({
  children: r,
  onSigninCallback: o,
  ...e
}) => /* @__PURE__ */ a(
  i,
  {
    onSigninCallback: (t) => {
      m(), o?.(t);
    },
    ...e,
    children: r
  }
);
export {
  h as AuthProvider
};
